import {
  SET_MODAL_TYPE,
  SET_PROGRESS_VALUE,
  TOGGLE_CUSTOM_MODAL,
} from '../actionConstants';

const defaultState = {
  isCustomModalShown: false,
  progressValue: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_MODAL_TYPE:
      return {
        ...state,
        modalType: action.modalType,
        modalProps: action.modalProps,
        progressValue: {},
      };
    case TOGGLE_CUSTOM_MODAL: {
      return {
        ...state,
        isCustomModalShown: action.isCustomModalShown,
      };
    }
    case SET_PROGRESS_VALUE: {
      return {
        ...state,
        progressValue: {
          ...state.progressValue,
          [action.id]: action.progressValue,
        },
      };
    }
    default:
      return state;
  }
};
